exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rules-card{max-width:95%}md-input.red-label .input-field>label{color:red}md-input.yellow-label .input-field>label{color:#fbc02d}", ""]);

